/*!

=========================================================
* Argon Design System React - v1.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-design-system-react
* Copyright 2020 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/argon-design-system-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React, { useState,useEffect,useRef  } from "react";
import ReactDOM from "react-dom";
import axios from 'axios';
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
// reactstrap components
import { Container, Row, Col } from "reactstrap";
import { Table } from 'reactstrap';
import { Button } from "reactstrap";
import { Modal, ModalHeader, ModalBody, ModalFooter, Input, Label, Form, FormGroup } from 'reactstrap';
import { connect } from 'react-redux';
import {setProducts, initQuote, setCompany} from '../../actions/quote'
import Category from "../Category.js"
import {supplier_arry} from "../../config"
import Lightbox from 'react-image-lightbox';
import { API_URL, downloadFile } from"../../network"
import Moment from 'react-moment';


// core components
import DemoNavbar from "components/Navbars/DemoNavbar.js";
import CardsFooter from "components/Footers/CardsFooter.js";
import {
  SortableContainer,
  SortableElement,
  arrayMove
} from "react-sortable-hoc";

import "react-virtualized/styles.css";
import "assets/vendor/font-awesome/css/font-awesome.min.css";
// index page sections
// import Hero from "./IndexSections/Hero.js";
// import Buttons from "./IndexSections/Buttons.js";
// import Inputs from "./IndexSections/Inputs.js";
// import CustomControls from "./IndexSections/CustomControls.js";
// import Menus from "./IndexSections/Menus.js";
// import Navbars from "./IndexSections/Navbars.js";
// import Tabs from "./IndexSections/Tabs.js";
// import Progress from "./IndexSections/Progress.js";
// import Pagination from "./IndexSections/Pagination.js";
// import Pills from "./IndexSections/Pills.js";
// import Labels from "./IndexSections/Labels.js";
// import Alerts from "./IndexSections/Alerts.js";
// import Typography from "./IndexSections/Typography.js";
// import Datepicker from "./IndexSections/Datepicker.js";
// import TooltipPopover from "./IndexSections/TooltipPopover.js";
// import Carousel from "./IndexSections/Carousel.js";
// import Icons from "./IndexSections/Icons.js";
// import Login from "./IndexSections/Login.js";
// import Download from "./IndexSections/Download.js";
import { Tooltip } from 'reactstrap';
import classnames from 'classnames';
import LoadingOverlay from 'react-loading-overlay';
import { toast } from 'react-toastify';
import 'react-inner-image-zoom/lib/InnerImageZoom/styles.css';

function Index(props) {
  const [tableData, setTableData] = useState([]);
  const [tooltipStatus, setTooltipStatus] = useState(false);
  const [tooltipValid, setTooltipValid] = useState(false);
  const [modalImage, setModalImage] = useState(false)
  const [openLogoImage, setOpenLogoImage] = useState(false)
  const [logOpen, setLogOpen] = useState(false)
  const [logData, setLogData] = useState("")


  const toggleTooltipStatus = () => setTooltipStatus(!tooltipStatus);
  const toggleTooltipValid = () => setTooltipValid(!tooltipValid);

  useEffect(() => {
    getData();
  },[props.selectedUser,props.selectedContact]);

  const showLogo = (item)=>{    
    axios.get(`/quotes/logo/${item['id']}`).then(res => {
      setOpenLogoImage(true)
        setModalImage('data:image/png;base64, '+res.data)
    })    
  }

  const viewLog = (id)=>{
    axios.get(`/quotes/getlog/${id}`).then(res => {
      setLogOpen(true)
      setLogData(res.data)
    })    
  }
  
  const toggleProductImage = () => {
    console.log("toggle");
    setOpenLogoImage(!openLogoImage);
  }


  const getData = ()=>{
    props.initQuote()
    props.setCompany(null)
    axios.get(`/quotes/index?userid=${props.selectedUser?props.selectedUser:''}&contactid=${props.selectedContact?props.selectedContact:''}`).then(res => {
      console.log('res.data',res.data)
      if(res.data.status == "success")
        setTableData(res.data.data);
    })    
  }

  const submitReady = (quoteId, value)=>{
    var bodyFormData = new FormData();
    bodyFormData.append('ready', value?1:0);

    axios.post(`/quotes/setready/${quoteId}`, bodyFormData).then(res => {
      const result = res.data;
      if(result.status == "success"){ 
        toast.success('You have set successfully');
        getData(props.selectedUser);
      }
      else{
        toast.error(result.data);
      }
    }).catch(err => {
      toast.error('Something was wrong. Try again');
    })
  }


  const submitSent = (quoteId, value)=>{
    var bodyFormData = new FormData();
    bodyFormData.append('sent', value?1:0);

    axios.post(`/quotes/setsent/${quoteId}`, bodyFormData).then(res => {
      const result = res.data;
      if(result.status == "success"){ 
        toast.success('You have set successfully');
        getData(props.selectedUser);
      }
      else{
        toast.error(result.data);
      }
    }).catch(err => {
      toast.error('Something was wrong. Try again');
    })
  }
  const token = localStorage.getItem('token_bigbrand');    
  const user = localStorage.getItem('user_bigbrand');
  var role = ""
  if(user && user != undefined){
    var userinfo = JSON.parse(user)
    role = userinfo['role']
  }
  return (
    <>    
    <Row className="mt-4" id="quotes_section">
        <Col md="12">
          <Table className="mt-3" striped >  
            <thead>
              <tr>
                <th></th>
                <th>No.</th>
                <th>Name</th>
                <th>
                  <div className="d-flex align-items-center">
                    <span>Status</span>
                    <label className="help-icon" style={{margin:"2px 0 0 11px"}} href="#" id="tooltipStatus" >i</label>
                    <Tooltip placement="bottom" isOpen={tooltipStatus} className="text-left" target="tooltipStatus" toggle={toggleTooltipStatus}>
                      Status<br/>
                    </Tooltip>
                  </div>
                </th>
                <th>Created</th>
                <th>
                  <div className="d-flex align-items-center">
                    <span>Valid Until</span>
                    <label className="help-icon" style={{margin:"2px 0 0 11px"}} href="#" id="tooltipValid" >i</label>
                    <Tooltip placement="bottom" isOpen={tooltipValid} className="text-left" target="tooltipValid" toggle={toggleTooltipValid}>
                      valid until<br/>
                    </Tooltip>
                  </div>
                </th>
                <th>History</th>
                <th>Total</th>
                <th>Ready/<br/>Review</th>
                <th>Sent</th>
                <th>View</th>
              </tr>
            </thead>               
            <tbody>
              {
                tableData.map((row, index)=>{
                  return (
                    <tr>
                      <td width="50px" className="pl-2 pr-2" scope="row">
                        <span style={{cursor:"pointer"}} onClick={()=>{showLogo(row)}} width="50px" height="50px"> <i className="fa fa-camera" aria-hidden="true"></i></span>
                      </td>
                      <td>
                        #{row['id']}
                      </td>
                      <td>
                        {(row['label']?row['label']:"")+(row['revision']?(" - R"+row['revision']):"")}
                      </td>
                      <td className="pl-2 pr-2">
                        {row['status']}
                      </td>
                      <td className="pl-2 pr-2">      
                      {row['updated_at']?                  
                        <Moment format="DD/MM/YYYY">
                          {row['updated_at']}
                        </Moment>
                        :""
                      }
                      </td>
                      <td className="pl-2 pr-2">
                        {row['valid_to']?                  
                          <Moment format="DD/MM/YYYY">
                            {row['valid_to']}
                          </Moment>
                          :""
                        }
                      </td>
                      <td className="pl-2 pr-2">
                        <Button size="sm"
                          onClick={()=>{viewLog(row['id'])}} outline
                          className="btn-icon btn-3 rounded-0 border-3" color="primary" type="button">
                          <span className="btn-inner--text ">View</span>
                        </Button>
                      </td>
                      <td className="pl-2 pr-2">
                      ${row['price']?(row['price']+row['price']/10).toFixed(2):0}
                      </td>
                      <td className="pl-2 pr-2">
                        <div className="custom-control custom-control-alternative custom-checkbox">
                          <input
                            className="custom-control-input"
                            id={`customCheckReady${index}`}
                            type="checkbox"
                            checked={row['ready']}
                            onChange={()=>submitReady(row['id'], !row['ready'])}
                          />
                          <label
                            className="custom-control-label"
                            htmlFor={`customCheckReady${index}`}
                          >
                            <span></span>
                          </label>
                        </div>
                      </td>
                      <td className="pl-2 pr-2">
                        <div className="custom-control custom-control-alternative custom-checkbox">
                          <input
                            className="custom-control-input"
                            id={`customCheckSent${index}`}
                            type="checkbox"
                            checked={row['sent']}
                            onChange={()=>submitSent(row['id'], !row['sent'])}
                          />
                          <label
                            className="custom-control-label"
                            htmlFor={`customCheckSent${index}`}
                          >
                            <span></span>
                          </label>
                        </div>
                      </td>
                      <td>                        
                        <Button size="sm"
                          onClick={()=>role=='admin'?props.history.push(("/admin/requests/edit/")+row['id']):props.history.push(("/requests/edit/")+row['id'])}
                          className="btn-icon btn-3 rounded-0 border-3" color="primary" type="button">
                          <span className="btn-inner--text">View </span>
                        </Button>
                      </td>
                    </tr>
                  )
                })
              }
            </tbody>
          </Table>
        </Col>
      </Row>   
      {openLogoImage && (
        <Lightbox
          mainSrc={modalImage?modalImage:require("assets/img/theme/product-placeholder.jpg")}
          
          onCloseRequest={() => toggleProductImage()}
        />
      )} 
      
      <Modal isOpen={logOpen} toggle={()=>setLogOpen(false)} >
        <ModalHeader toggle={()=>setLogOpen(false)}>History</ModalHeader>
        <ModalBody>
            <FormGroup>
              <Input style={{whitespace: 'pre-line', maxHeight:150, overflowY:'auto'}} disabled type="textarea" rows="8" value={logData?logData:""}/> 
            </FormGroup>
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" size="sm" onClick={()=>setLogOpen(false)}>Close</Button>
        </ModalFooter>
      </Modal>
    </>
  );
}


const mapStateToProps = (state) => {
  return {
    quote: state.quote,
  };
};

const mapDispatchProps = (dispatch) => {
  return {    
    setProducts: products=>dispatch(setProducts(products)),
    initQuote:()=>dispatch(initQuote()),
    setCompany:(data)=>dispatch(setCompany(data)),
  };
};

export default connect(mapStateToProps, mapDispatchProps)(Index);
